import type { StrictOmit } from '@frontend/duck-tape';
import type { ClassName } from '@frontend/web-utils';
import { mergeAndConcatClasses } from '@frontend/web-utils';
import { Button } from '../Buttons';
import { XStack, YStack } from '../Containers';
import type { IconProps } from '../Icon/Icon';
import { Icon } from '../Icon/Icon';
import type { IconName } from '../Icon/helpers';
import { Text } from '../Texts/Text';

export type EmptyListProps = {
  buttonLabel?: string;
  className?: ClassName;
  iconName?: IconName;
  iconProps?: StrictOmit<IconProps, 'name'>;
  label?: string;
  onClickButton?: () => void;
  subLabel?: string;
};
export const EmptyList = ({ buttonLabel, className, iconName, label, onClickButton, subLabel }: EmptyListProps) => {
  //   const { track } = useSegment();
  return (
    // eslint-disable-next-line tailwindcss/no-arbitrary-value
    <YStack
      className={mergeAndConcatClasses('gap-y-lg h-[60vh] items-center justify-center text-center', className)}
      role="list"
    >
      {iconName ? <Icon name={iconName} /> : null}
      {label ? (
        // eslint-disable-next-line tailwindcss/no-arbitrary-value
        <Text className="max-w-[480px]" textAlign="center" type="h4">
          {label}
        </Text>
      ) : null}
      {subLabel ? (
        // eslint-disable-next-line tailwindcss/no-arbitrary-value
        <Text className="max-w-[480px]" color="tertiary" textAlign="center" type="p-sm">
          {subLabel}
        </Text>
      ) : null}
      {buttonLabel ? (
        <XStack>
          <Button label={buttonLabel} onClick={onClickButton} />
        </XStack>
      ) : null}
    </YStack>
  );
};
